/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TradesRouteImport } from './routes/trades'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IngestRouteImport } from './routes/ingest'
import { Route as GridRouteImport } from './routes/grid'
import { Route as GeneratorRouteImport } from './routes/generator'
import { Route as ForecastingRouteImport } from './routes/forecasting'
import { Route as ChangePasswordRouteImport } from './routes/change-password'
import { Route as BalancingRouteImport } from './routes/balancing'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as EexIndexRouteImport } from './routes/eex.index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as SettingsBrmRouteImport } from './routes/settings.brm'
import { Route as ForecastingProfileBuilderRouteImport } from './routes/forecasting.profile-builder'
import { Route as ForecastingMonthViewRouteImport } from './routes/forecasting.month-view'
import { Route as ForecastingContractsRouteImport } from './routes/forecasting.contracts'
import { Route as ForecastingConsumptionRouteImport } from './routes/forecasting.consumption'
import { Route as EexTradesRouteImport } from './routes/eex.trades'
import { Route as EexStatsRouteImport } from './routes/eex.stats'
import { Route as EexStatementsRouteImport } from './routes/eex.statements'
import { Route as EexSettingsRouteImport } from './routes/eex.settings'
import { Route as EexResearchRouteImport } from './routes/eex.research'
import { Route as EexRecognitionSchedulesRouteImport } from './routes/eex.recognition-schedules'
import { Route as EexQuotesRouteImport } from './routes/eex.quotes'
import { Route as EexPositionsTreeRouteImport } from './routes/eex.positions-tree'
import { Route as EexPositionsRouteImport } from './routes/eex.positions'
import { Route as EexPnlRouteImport } from './routes/eex.pnl'
import { Route as EexMatchingRouteImport } from './routes/eex.matching'
import { Route as EexMarketDataRouteImport } from './routes/eex.market-data'
import { Route as EexMarginLabRouteImport } from './routes/eex.margin-lab'
import { Route as EexMarginRouteImport } from './routes/eex.margin'
import { Route as EexFxRouteImport } from './routes/eex.fx'
import { Route as EexDeliveryRouteImport } from './routes/eex.delivery'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminTransactionsRouteImport } from './routes/admin.transactions'
import { Route as AdminOnboardingGuideRouteImport } from './routes/admin.onboarding-guide'
import { Route as AdminOnboardingRouteImport } from './routes/admin.onboarding'
import { Route as AdminInboxRouteImport } from './routes/admin.inbox'
import { Route as AdminGuideRouteImport } from './routes/admin.guide'
import { Route as AdminGlobalAdminsRouteImport } from './routes/admin.global-admins'
import { Route as AdminEntsoeRouteImport } from './routes/admin.entsoe'
import { Route as AdminCompaniesRouteImport } from './routes/admin.companies'
import { Route as AdminClientsRouteImport } from './routes/admin.clients'
import { Route as AdminBillingRouteImport } from './routes/admin.billing'
import { Route as AdminActivityRouteImport } from './routes/admin.activity'
import { Route as AdminOnboardingIndexRouteImport } from './routes/admin.onboarding.index'
import { Route as AdminClientsIndexRouteImport } from './routes/admin.clients.index'
import { Route as AdminOnboardingOperationIdRouteImport } from './routes/admin.onboarding.$operationId'
import { Route as AdminClientsClientIdRouteImport } from './routes/admin.clients.$clientId'

const TradesRoute = TradesRouteImport.update({
  id: '/trades',
  path: '/trades',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IngestRoute = IngestRouteImport.update({
  id: '/ingest',
  path: '/ingest',
  getParentRoute: () => rootRouteImport,
} as any)
const GridRoute = GridRouteImport.update({
  id: '/grid',
  path: '/grid',
  getParentRoute: () => rootRouteImport,
} as any)
const GeneratorRoute = GeneratorRouteImport.update({
  id: '/generator',
  path: '/generator',
  getParentRoute: () => rootRouteImport,
} as any)
const ForecastingRoute = ForecastingRouteImport.update({
  id: '/forecasting',
  path: '/forecasting',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const BalancingRoute = BalancingRouteImport.update({
  id: '/balancing',
  path: '/balancing',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const EexIndexRoute = EexIndexRouteImport.update({
  id: '/eex/',
  path: '/eex/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const SettingsBrmRoute = SettingsBrmRouteImport.update({
  id: '/settings/brm',
  path: '/settings/brm',
  getParentRoute: () => rootRouteImport,
} as any)
const ForecastingProfileBuilderRoute =
  ForecastingProfileBuilderRouteImport.update({
    id: '/profile-builder',
    path: '/profile-builder',
    getParentRoute: () => ForecastingRoute,
  } as any)
const ForecastingMonthViewRoute = ForecastingMonthViewRouteImport.update({
  id: '/month-view',
  path: '/month-view',
  getParentRoute: () => ForecastingRoute,
} as any)
const ForecastingContractsRoute = ForecastingContractsRouteImport.update({
  id: '/contracts',
  path: '/contracts',
  getParentRoute: () => ForecastingRoute,
} as any)
const ForecastingConsumptionRoute = ForecastingConsumptionRouteImport.update({
  id: '/consumption',
  path: '/consumption',
  getParentRoute: () => ForecastingRoute,
} as any)
const EexTradesRoute = EexTradesRouteImport.update({
  id: '/eex/trades',
  path: '/eex/trades',
  getParentRoute: () => rootRouteImport,
} as any)
const EexStatsRoute = EexStatsRouteImport.update({
  id: '/eex/stats',
  path: '/eex/stats',
  getParentRoute: () => rootRouteImport,
} as any)
const EexStatementsRoute = EexStatementsRouteImport.update({
  id: '/eex/statements',
  path: '/eex/statements',
  getParentRoute: () => rootRouteImport,
} as any)
const EexSettingsRoute = EexSettingsRouteImport.update({
  id: '/eex/settings',
  path: '/eex/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const EexResearchRoute = EexResearchRouteImport.update({
  id: '/eex/research',
  path: '/eex/research',
  getParentRoute: () => rootRouteImport,
} as any)
const EexRecognitionSchedulesRoute = EexRecognitionSchedulesRouteImport.update({
  id: '/eex/recognition-schedules',
  path: '/eex/recognition-schedules',
  getParentRoute: () => rootRouteImport,
} as any)
const EexQuotesRoute = EexQuotesRouteImport.update({
  id: '/eex/quotes',
  path: '/eex/quotes',
  getParentRoute: () => rootRouteImport,
} as any)
const EexPositionsTreeRoute = EexPositionsTreeRouteImport.update({
  id: '/eex/positions-tree',
  path: '/eex/positions-tree',
  getParentRoute: () => rootRouteImport,
} as any)
const EexPositionsRoute = EexPositionsRouteImport.update({
  id: '/eex/positions',
  path: '/eex/positions',
  getParentRoute: () => rootRouteImport,
} as any)
const EexPnlRoute = EexPnlRouteImport.update({
  id: '/eex/pnl',
  path: '/eex/pnl',
  getParentRoute: () => rootRouteImport,
} as any)
const EexMatchingRoute = EexMatchingRouteImport.update({
  id: '/eex/matching',
  path: '/eex/matching',
  getParentRoute: () => rootRouteImport,
} as any)
const EexMarketDataRoute = EexMarketDataRouteImport.update({
  id: '/eex/market-data',
  path: '/eex/market-data',
  getParentRoute: () => rootRouteImport,
} as any)
const EexMarginLabRoute = EexMarginLabRouteImport.update({
  id: '/eex/margin-lab',
  path: '/eex/margin-lab',
  getParentRoute: () => rootRouteImport,
} as any)
const EexMarginRoute = EexMarginRouteImport.update({
  id: '/eex/margin',
  path: '/eex/margin',
  getParentRoute: () => rootRouteImport,
} as any)
const EexFxRoute = EexFxRouteImport.update({
  id: '/eex/fx',
  path: '/eex/fx',
  getParentRoute: () => rootRouteImport,
} as any)
const EexDeliveryRoute = EexDeliveryRouteImport.update({
  id: '/eex/delivery',
  path: '/eex/delivery',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTransactionsRoute = AdminTransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOnboardingGuideRoute = AdminOnboardingGuideRouteImport.update({
  id: '/onboarding-guide',
  path: '/onboarding-guide',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOnboardingRoute = AdminOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AdminRoute,
} as any)
const AdminInboxRoute = AdminInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AdminRoute,
} as any)
const AdminGuideRoute = AdminGuideRouteImport.update({
  id: '/guide',
  path: '/guide',
  getParentRoute: () => AdminRoute,
} as any)
const AdminGlobalAdminsRoute = AdminGlobalAdminsRouteImport.update({
  id: '/global-admins',
  path: '/global-admins',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEntsoeRoute = AdminEntsoeRouteImport.update({
  id: '/entsoe',
  path: '/entsoe',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCompaniesRoute = AdminCompaniesRouteImport.update({
  id: '/companies',
  path: '/companies',
  getParentRoute: () => AdminRoute,
} as any)
const AdminClientsRoute = AdminClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBillingRoute = AdminBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AdminRoute,
} as any)
const AdminActivityRoute = AdminActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOnboardingIndexRoute = AdminOnboardingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminOnboardingRoute,
} as any)
const AdminClientsIndexRoute = AdminClientsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminClientsRoute,
} as any)
const AdminOnboardingOperationIdRoute =
  AdminOnboardingOperationIdRouteImport.update({
    id: '/$operationId',
    path: '/$operationId',
    getParentRoute: () => AdminOnboardingRoute,
  } as any)
const AdminClientsClientIdRoute = AdminClientsClientIdRouteImport.update({
  id: '/$clientId',
  path: '/$clientId',
  getParentRoute: () => AdminClientsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/balancing': typeof BalancingRoute
  '/change-password': typeof ChangePasswordRoute
  '/forecasting': typeof ForecastingRouteWithChildren
  '/generator': typeof GeneratorRoute
  '/grid': typeof GridRoute
  '/ingest': typeof IngestRoute
  '/login': typeof LoginRoute
  '/reports': typeof ReportsRoute
  '/trades': typeof TradesRoute
  '/admin/activity': typeof AdminActivityRoute
  '/admin/billing': typeof AdminBillingRoute
  '/admin/clients': typeof AdminClientsRouteWithChildren
  '/admin/companies': typeof AdminCompaniesRoute
  '/admin/entsoe': typeof AdminEntsoeRoute
  '/admin/global-admins': typeof AdminGlobalAdminsRoute
  '/admin/guide': typeof AdminGuideRoute
  '/admin/inbox': typeof AdminInboxRoute
  '/admin/onboarding': typeof AdminOnboardingRouteWithChildren
  '/admin/onboarding-guide': typeof AdminOnboardingGuideRoute
  '/admin/transactions': typeof AdminTransactionsRoute
  '/admin/users': typeof AdminUsersRoute
  '/eex/delivery': typeof EexDeliveryRoute
  '/eex/fx': typeof EexFxRoute
  '/eex/margin': typeof EexMarginRoute
  '/eex/margin-lab': typeof EexMarginLabRoute
  '/eex/market-data': typeof EexMarketDataRoute
  '/eex/matching': typeof EexMatchingRoute
  '/eex/pnl': typeof EexPnlRoute
  '/eex/positions': typeof EexPositionsRoute
  '/eex/positions-tree': typeof EexPositionsTreeRoute
  '/eex/quotes': typeof EexQuotesRoute
  '/eex/recognition-schedules': typeof EexRecognitionSchedulesRoute
  '/eex/research': typeof EexResearchRoute
  '/eex/settings': typeof EexSettingsRoute
  '/eex/statements': typeof EexStatementsRoute
  '/eex/stats': typeof EexStatsRoute
  '/eex/trades': typeof EexTradesRoute
  '/forecasting/consumption': typeof ForecastingConsumptionRoute
  '/forecasting/contracts': typeof ForecastingContractsRoute
  '/forecasting/month-view': typeof ForecastingMonthViewRoute
  '/forecasting/profile-builder': typeof ForecastingProfileBuilderRoute
  '/settings/brm': typeof SettingsBrmRoute
  '/admin/': typeof AdminIndexRoute
  '/eex/': typeof EexIndexRoute
  '/admin/clients/$clientId': typeof AdminClientsClientIdRoute
  '/admin/onboarding/$operationId': typeof AdminOnboardingOperationIdRoute
  '/admin/clients/': typeof AdminClientsIndexRoute
  '/admin/onboarding/': typeof AdminOnboardingIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/balancing': typeof BalancingRoute
  '/change-password': typeof ChangePasswordRoute
  '/forecasting': typeof ForecastingRouteWithChildren
  '/generator': typeof GeneratorRoute
  '/grid': typeof GridRoute
  '/ingest': typeof IngestRoute
  '/login': typeof LoginRoute
  '/reports': typeof ReportsRoute
  '/trades': typeof TradesRoute
  '/admin/activity': typeof AdminActivityRoute
  '/admin/billing': typeof AdminBillingRoute
  '/admin/companies': typeof AdminCompaniesRoute
  '/admin/entsoe': typeof AdminEntsoeRoute
  '/admin/global-admins': typeof AdminGlobalAdminsRoute
  '/admin/guide': typeof AdminGuideRoute
  '/admin/inbox': typeof AdminInboxRoute
  '/admin/onboarding-guide': typeof AdminOnboardingGuideRoute
  '/admin/transactions': typeof AdminTransactionsRoute
  '/admin/users': typeof AdminUsersRoute
  '/eex/delivery': typeof EexDeliveryRoute
  '/eex/fx': typeof EexFxRoute
  '/eex/margin': typeof EexMarginRoute
  '/eex/margin-lab': typeof EexMarginLabRoute
  '/eex/market-data': typeof EexMarketDataRoute
  '/eex/matching': typeof EexMatchingRoute
  '/eex/pnl': typeof EexPnlRoute
  '/eex/positions': typeof EexPositionsRoute
  '/eex/positions-tree': typeof EexPositionsTreeRoute
  '/eex/quotes': typeof EexQuotesRoute
  '/eex/recognition-schedules': typeof EexRecognitionSchedulesRoute
  '/eex/research': typeof EexResearchRoute
  '/eex/settings': typeof EexSettingsRoute
  '/eex/statements': typeof EexStatementsRoute
  '/eex/stats': typeof EexStatsRoute
  '/eex/trades': typeof EexTradesRoute
  '/forecasting/consumption': typeof ForecastingConsumptionRoute
  '/forecasting/contracts': typeof ForecastingContractsRoute
  '/forecasting/month-view': typeof ForecastingMonthViewRoute
  '/forecasting/profile-builder': typeof ForecastingProfileBuilderRoute
  '/settings/brm': typeof SettingsBrmRoute
  '/admin': typeof AdminIndexRoute
  '/eex': typeof EexIndexRoute
  '/admin/clients/$clientId': typeof AdminClientsClientIdRoute
  '/admin/onboarding/$operationId': typeof AdminOnboardingOperationIdRoute
  '/admin/clients': typeof AdminClientsIndexRoute
  '/admin/onboarding': typeof AdminOnboardingIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/balancing': typeof BalancingRoute
  '/change-password': typeof ChangePasswordRoute
  '/forecasting': typeof ForecastingRouteWithChildren
  '/generator': typeof GeneratorRoute
  '/grid': typeof GridRoute
  '/ingest': typeof IngestRoute
  '/login': typeof LoginRoute
  '/reports': typeof ReportsRoute
  '/trades': typeof TradesRoute
  '/admin/activity': typeof AdminActivityRoute
  '/admin/billing': typeof AdminBillingRoute
  '/admin/clients': typeof AdminClientsRouteWithChildren
  '/admin/companies': typeof AdminCompaniesRoute
  '/admin/entsoe': typeof AdminEntsoeRoute
  '/admin/global-admins': typeof AdminGlobalAdminsRoute
  '/admin/guide': typeof AdminGuideRoute
  '/admin/inbox': typeof AdminInboxRoute
  '/admin/onboarding': typeof AdminOnboardingRouteWithChildren
  '/admin/onboarding-guide': typeof AdminOnboardingGuideRoute
  '/admin/transactions': typeof AdminTransactionsRoute
  '/admin/users': typeof AdminUsersRoute
  '/eex/delivery': typeof EexDeliveryRoute
  '/eex/fx': typeof EexFxRoute
  '/eex/margin': typeof EexMarginRoute
  '/eex/margin-lab': typeof EexMarginLabRoute
  '/eex/market-data': typeof EexMarketDataRoute
  '/eex/matching': typeof EexMatchingRoute
  '/eex/pnl': typeof EexPnlRoute
  '/eex/positions': typeof EexPositionsRoute
  '/eex/positions-tree': typeof EexPositionsTreeRoute
  '/eex/quotes': typeof EexQuotesRoute
  '/eex/recognition-schedules': typeof EexRecognitionSchedulesRoute
  '/eex/research': typeof EexResearchRoute
  '/eex/settings': typeof EexSettingsRoute
  '/eex/statements': typeof EexStatementsRoute
  '/eex/stats': typeof EexStatsRoute
  '/eex/trades': typeof EexTradesRoute
  '/forecasting/consumption': typeof ForecastingConsumptionRoute
  '/forecasting/contracts': typeof ForecastingContractsRoute
  '/forecasting/month-view': typeof ForecastingMonthViewRoute
  '/forecasting/profile-builder': typeof ForecastingProfileBuilderRoute
  '/settings/brm': typeof SettingsBrmRoute
  '/admin/': typeof AdminIndexRoute
  '/eex/': typeof EexIndexRoute
  '/admin/clients/$clientId': typeof AdminClientsClientIdRoute
  '/admin/onboarding/$operationId': typeof AdminOnboardingOperationIdRoute
  '/admin/clients/': typeof AdminClientsIndexRoute
  '/admin/onboarding/': typeof AdminOnboardingIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/balancing'
    | '/change-password'
    | '/forecasting'
    | '/generator'
    | '/grid'
    | '/ingest'
    | '/login'
    | '/reports'
    | '/trades'
    | '/admin/activity'
    | '/admin/billing'
    | '/admin/clients'
    | '/admin/companies'
    | '/admin/entsoe'
    | '/admin/global-admins'
    | '/admin/guide'
    | '/admin/inbox'
    | '/admin/onboarding'
    | '/admin/onboarding-guide'
    | '/admin/transactions'
    | '/admin/users'
    | '/eex/delivery'
    | '/eex/fx'
    | '/eex/margin'
    | '/eex/margin-lab'
    | '/eex/market-data'
    | '/eex/matching'
    | '/eex/pnl'
    | '/eex/positions'
    | '/eex/positions-tree'
    | '/eex/quotes'
    | '/eex/recognition-schedules'
    | '/eex/research'
    | '/eex/settings'
    | '/eex/statements'
    | '/eex/stats'
    | '/eex/trades'
    | '/forecasting/consumption'
    | '/forecasting/contracts'
    | '/forecasting/month-view'
    | '/forecasting/profile-builder'
    | '/settings/brm'
    | '/admin/'
    | '/eex/'
    | '/admin/clients/$clientId'
    | '/admin/onboarding/$operationId'
    | '/admin/clients/'
    | '/admin/onboarding/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/balancing'
    | '/change-password'
    | '/forecasting'
    | '/generator'
    | '/grid'
    | '/ingest'
    | '/login'
    | '/reports'
    | '/trades'
    | '/admin/activity'
    | '/admin/billing'
    | '/admin/companies'
    | '/admin/entsoe'
    | '/admin/global-admins'
    | '/admin/guide'
    | '/admin/inbox'
    | '/admin/onboarding-guide'
    | '/admin/transactions'
    | '/admin/users'
    | '/eex/delivery'
    | '/eex/fx'
    | '/eex/margin'
    | '/eex/margin-lab'
    | '/eex/market-data'
    | '/eex/matching'
    | '/eex/pnl'
    | '/eex/positions'
    | '/eex/positions-tree'
    | '/eex/quotes'
    | '/eex/recognition-schedules'
    | '/eex/research'
    | '/eex/settings'
    | '/eex/statements'
    | '/eex/stats'
    | '/eex/trades'
    | '/forecasting/consumption'
    | '/forecasting/contracts'
    | '/forecasting/month-view'
    | '/forecasting/profile-builder'
    | '/settings/brm'
    | '/admin'
    | '/eex'
    | '/admin/clients/$clientId'
    | '/admin/onboarding/$operationId'
    | '/admin/clients'
    | '/admin/onboarding'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/balancing'
    | '/change-password'
    | '/forecasting'
    | '/generator'
    | '/grid'
    | '/ingest'
    | '/login'
    | '/reports'
    | '/trades'
    | '/admin/activity'
    | '/admin/billing'
    | '/admin/clients'
    | '/admin/companies'
    | '/admin/entsoe'
    | '/admin/global-admins'
    | '/admin/guide'
    | '/admin/inbox'
    | '/admin/onboarding'
    | '/admin/onboarding-guide'
    | '/admin/transactions'
    | '/admin/users'
    | '/eex/delivery'
    | '/eex/fx'
    | '/eex/margin'
    | '/eex/margin-lab'
    | '/eex/market-data'
    | '/eex/matching'
    | '/eex/pnl'
    | '/eex/positions'
    | '/eex/positions-tree'
    | '/eex/quotes'
    | '/eex/recognition-schedules'
    | '/eex/research'
    | '/eex/settings'
    | '/eex/statements'
    | '/eex/stats'
    | '/eex/trades'
    | '/forecasting/consumption'
    | '/forecasting/contracts'
    | '/forecasting/month-view'
    | '/forecasting/profile-builder'
    | '/settings/brm'
    | '/admin/'
    | '/eex/'
    | '/admin/clients/$clientId'
    | '/admin/onboarding/$operationId'
    | '/admin/clients/'
    | '/admin/onboarding/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  BalancingRoute: typeof BalancingRoute
  ChangePasswordRoute: typeof ChangePasswordRoute
  ForecastingRoute: typeof ForecastingRouteWithChildren
  GeneratorRoute: typeof GeneratorRoute
  GridRoute: typeof GridRoute
  IngestRoute: typeof IngestRoute
  LoginRoute: typeof LoginRoute
  ReportsRoute: typeof ReportsRoute
  TradesRoute: typeof TradesRoute
  EexDeliveryRoute: typeof EexDeliveryRoute
  EexFxRoute: typeof EexFxRoute
  EexMarginRoute: typeof EexMarginRoute
  EexMarginLabRoute: typeof EexMarginLabRoute
  EexMarketDataRoute: typeof EexMarketDataRoute
  EexMatchingRoute: typeof EexMatchingRoute
  EexPnlRoute: typeof EexPnlRoute
  EexPositionsRoute: typeof EexPositionsRoute
  EexPositionsTreeRoute: typeof EexPositionsTreeRoute
  EexQuotesRoute: typeof EexQuotesRoute
  EexRecognitionSchedulesRoute: typeof EexRecognitionSchedulesRoute
  EexResearchRoute: typeof EexResearchRoute
  EexSettingsRoute: typeof EexSettingsRoute
  EexStatementsRoute: typeof EexStatementsRoute
  EexStatsRoute: typeof EexStatsRoute
  EexTradesRoute: typeof EexTradesRoute
  SettingsBrmRoute: typeof SettingsBrmRoute
  EexIndexRoute: typeof EexIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/trades': {
      id: '/trades'
      path: '/trades'
      fullPath: '/trades'
      preLoaderRoute: typeof TradesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ingest': {
      id: '/ingest'
      path: '/ingest'
      fullPath: '/ingest'
      preLoaderRoute: typeof IngestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/grid': {
      id: '/grid'
      path: '/grid'
      fullPath: '/grid'
      preLoaderRoute: typeof GridRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/generator': {
      id: '/generator'
      path: '/generator'
      fullPath: '/generator'
      preLoaderRoute: typeof GeneratorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forecasting': {
      id: '/forecasting'
      path: '/forecasting'
      fullPath: '/forecasting'
      preLoaderRoute: typeof ForecastingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/balancing': {
      id: '/balancing'
      path: '/balancing'
      fullPath: '/balancing'
      preLoaderRoute: typeof BalancingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eex/': {
      id: '/eex/'
      path: '/eex'
      fullPath: '/eex/'
      preLoaderRoute: typeof EexIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/settings/brm': {
      id: '/settings/brm'
      path: '/settings/brm'
      fullPath: '/settings/brm'
      preLoaderRoute: typeof SettingsBrmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forecasting/profile-builder': {
      id: '/forecasting/profile-builder'
      path: '/profile-builder'
      fullPath: '/forecasting/profile-builder'
      preLoaderRoute: typeof ForecastingProfileBuilderRouteImport
      parentRoute: typeof ForecastingRoute
    }
    '/forecasting/month-view': {
      id: '/forecasting/month-view'
      path: '/month-view'
      fullPath: '/forecasting/month-view'
      preLoaderRoute: typeof ForecastingMonthViewRouteImport
      parentRoute: typeof ForecastingRoute
    }
    '/forecasting/contracts': {
      id: '/forecasting/contracts'
      path: '/contracts'
      fullPath: '/forecasting/contracts'
      preLoaderRoute: typeof ForecastingContractsRouteImport
      parentRoute: typeof ForecastingRoute
    }
    '/forecasting/consumption': {
      id: '/forecasting/consumption'
      path: '/consumption'
      fullPath: '/forecasting/consumption'
      preLoaderRoute: typeof ForecastingConsumptionRouteImport
      parentRoute: typeof ForecastingRoute
    }
    '/eex/trades': {
      id: '/eex/trades'
      path: '/eex/trades'
      fullPath: '/eex/trades'
      preLoaderRoute: typeof EexTradesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eex/stats': {
      id: '/eex/stats'
      path: '/eex/stats'
      fullPath: '/eex/stats'
      preLoaderRoute: typeof EexStatsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eex/statements': {
      id: '/eex/statements'
      path: '/eex/statements'
      fullPath: '/eex/statements'
      preLoaderRoute: typeof EexStatementsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eex/settings': {
      id: '/eex/settings'
      path: '/eex/settings'
      fullPath: '/eex/settings'
      preLoaderRoute: typeof EexSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eex/research': {
      id: '/eex/research'
      path: '/eex/research'
      fullPath: '/eex/research'
      preLoaderRoute: typeof EexResearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eex/recognition-schedules': {
      id: '/eex/recognition-schedules'
      path: '/eex/recognition-schedules'
      fullPath: '/eex/recognition-schedules'
      preLoaderRoute: typeof EexRecognitionSchedulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eex/quotes': {
      id: '/eex/quotes'
      path: '/eex/quotes'
      fullPath: '/eex/quotes'
      preLoaderRoute: typeof EexQuotesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eex/positions-tree': {
      id: '/eex/positions-tree'
      path: '/eex/positions-tree'
      fullPath: '/eex/positions-tree'
      preLoaderRoute: typeof EexPositionsTreeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eex/positions': {
      id: '/eex/positions'
      path: '/eex/positions'
      fullPath: '/eex/positions'
      preLoaderRoute: typeof EexPositionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eex/pnl': {
      id: '/eex/pnl'
      path: '/eex/pnl'
      fullPath: '/eex/pnl'
      preLoaderRoute: typeof EexPnlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eex/matching': {
      id: '/eex/matching'
      path: '/eex/matching'
      fullPath: '/eex/matching'
      preLoaderRoute: typeof EexMatchingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eex/market-data': {
      id: '/eex/market-data'
      path: '/eex/market-data'
      fullPath: '/eex/market-data'
      preLoaderRoute: typeof EexMarketDataRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eex/margin-lab': {
      id: '/eex/margin-lab'
      path: '/eex/margin-lab'
      fullPath: '/eex/margin-lab'
      preLoaderRoute: typeof EexMarginLabRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eex/margin': {
      id: '/eex/margin'
      path: '/eex/margin'
      fullPath: '/eex/margin'
      preLoaderRoute: typeof EexMarginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eex/fx': {
      id: '/eex/fx'
      path: '/eex/fx'
      fullPath: '/eex/fx'
      preLoaderRoute: typeof EexFxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eex/delivery': {
      id: '/eex/delivery'
      path: '/eex/delivery'
      fullPath: '/eex/delivery'
      preLoaderRoute: typeof EexDeliveryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/transactions': {
      id: '/admin/transactions'
      path: '/transactions'
      fullPath: '/admin/transactions'
      preLoaderRoute: typeof AdminTransactionsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/onboarding-guide': {
      id: '/admin/onboarding-guide'
      path: '/onboarding-guide'
      fullPath: '/admin/onboarding-guide'
      preLoaderRoute: typeof AdminOnboardingGuideRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/onboarding': {
      id: '/admin/onboarding'
      path: '/onboarding'
      fullPath: '/admin/onboarding'
      preLoaderRoute: typeof AdminOnboardingRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/inbox': {
      id: '/admin/inbox'
      path: '/inbox'
      fullPath: '/admin/inbox'
      preLoaderRoute: typeof AdminInboxRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/guide': {
      id: '/admin/guide'
      path: '/guide'
      fullPath: '/admin/guide'
      preLoaderRoute: typeof AdminGuideRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/global-admins': {
      id: '/admin/global-admins'
      path: '/global-admins'
      fullPath: '/admin/global-admins'
      preLoaderRoute: typeof AdminGlobalAdminsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/entsoe': {
      id: '/admin/entsoe'
      path: '/entsoe'
      fullPath: '/admin/entsoe'
      preLoaderRoute: typeof AdminEntsoeRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/companies': {
      id: '/admin/companies'
      path: '/companies'
      fullPath: '/admin/companies'
      preLoaderRoute: typeof AdminCompaniesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/clients': {
      id: '/admin/clients'
      path: '/clients'
      fullPath: '/admin/clients'
      preLoaderRoute: typeof AdminClientsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/billing': {
      id: '/admin/billing'
      path: '/billing'
      fullPath: '/admin/billing'
      preLoaderRoute: typeof AdminBillingRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/activity': {
      id: '/admin/activity'
      path: '/activity'
      fullPath: '/admin/activity'
      preLoaderRoute: typeof AdminActivityRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/onboarding/': {
      id: '/admin/onboarding/'
      path: '/'
      fullPath: '/admin/onboarding/'
      preLoaderRoute: typeof AdminOnboardingIndexRouteImport
      parentRoute: typeof AdminOnboardingRoute
    }
    '/admin/clients/': {
      id: '/admin/clients/'
      path: '/'
      fullPath: '/admin/clients/'
      preLoaderRoute: typeof AdminClientsIndexRouteImport
      parentRoute: typeof AdminClientsRoute
    }
    '/admin/onboarding/$operationId': {
      id: '/admin/onboarding/$operationId'
      path: '/$operationId'
      fullPath: '/admin/onboarding/$operationId'
      preLoaderRoute: typeof AdminOnboardingOperationIdRouteImport
      parentRoute: typeof AdminOnboardingRoute
    }
    '/admin/clients/$clientId': {
      id: '/admin/clients/$clientId'
      path: '/$clientId'
      fullPath: '/admin/clients/$clientId'
      preLoaderRoute: typeof AdminClientsClientIdRouteImport
      parentRoute: typeof AdminClientsRoute
    }
  }
}

interface AdminClientsRouteChildren {
  AdminClientsClientIdRoute: typeof AdminClientsClientIdRoute
  AdminClientsIndexRoute: typeof AdminClientsIndexRoute
}

const AdminClientsRouteChildren: AdminClientsRouteChildren = {
  AdminClientsClientIdRoute: AdminClientsClientIdRoute,
  AdminClientsIndexRoute: AdminClientsIndexRoute,
}

const AdminClientsRouteWithChildren = AdminClientsRoute._addFileChildren(
  AdminClientsRouteChildren,
)

interface AdminOnboardingRouteChildren {
  AdminOnboardingOperationIdRoute: typeof AdminOnboardingOperationIdRoute
  AdminOnboardingIndexRoute: typeof AdminOnboardingIndexRoute
}

const AdminOnboardingRouteChildren: AdminOnboardingRouteChildren = {
  AdminOnboardingOperationIdRoute: AdminOnboardingOperationIdRoute,
  AdminOnboardingIndexRoute: AdminOnboardingIndexRoute,
}

const AdminOnboardingRouteWithChildren = AdminOnboardingRoute._addFileChildren(
  AdminOnboardingRouteChildren,
)

interface AdminRouteChildren {
  AdminActivityRoute: typeof AdminActivityRoute
  AdminBillingRoute: typeof AdminBillingRoute
  AdminClientsRoute: typeof AdminClientsRouteWithChildren
  AdminCompaniesRoute: typeof AdminCompaniesRoute
  AdminEntsoeRoute: typeof AdminEntsoeRoute
  AdminGlobalAdminsRoute: typeof AdminGlobalAdminsRoute
  AdminGuideRoute: typeof AdminGuideRoute
  AdminInboxRoute: typeof AdminInboxRoute
  AdminOnboardingRoute: typeof AdminOnboardingRouteWithChildren
  AdminOnboardingGuideRoute: typeof AdminOnboardingGuideRoute
  AdminTransactionsRoute: typeof AdminTransactionsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminActivityRoute: AdminActivityRoute,
  AdminBillingRoute: AdminBillingRoute,
  AdminClientsRoute: AdminClientsRouteWithChildren,
  AdminCompaniesRoute: AdminCompaniesRoute,
  AdminEntsoeRoute: AdminEntsoeRoute,
  AdminGlobalAdminsRoute: AdminGlobalAdminsRoute,
  AdminGuideRoute: AdminGuideRoute,
  AdminInboxRoute: AdminInboxRoute,
  AdminOnboardingRoute: AdminOnboardingRouteWithChildren,
  AdminOnboardingGuideRoute: AdminOnboardingGuideRoute,
  AdminTransactionsRoute: AdminTransactionsRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface ForecastingRouteChildren {
  ForecastingConsumptionRoute: typeof ForecastingConsumptionRoute
  ForecastingContractsRoute: typeof ForecastingContractsRoute
  ForecastingMonthViewRoute: typeof ForecastingMonthViewRoute
  ForecastingProfileBuilderRoute: typeof ForecastingProfileBuilderRoute
}

const ForecastingRouteChildren: ForecastingRouteChildren = {
  ForecastingConsumptionRoute: ForecastingConsumptionRoute,
  ForecastingContractsRoute: ForecastingContractsRoute,
  ForecastingMonthViewRoute: ForecastingMonthViewRoute,
  ForecastingProfileBuilderRoute: ForecastingProfileBuilderRoute,
}

const ForecastingRouteWithChildren = ForecastingRoute._addFileChildren(
  ForecastingRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  BalancingRoute: BalancingRoute,
  ChangePasswordRoute: ChangePasswordRoute,
  ForecastingRoute: ForecastingRouteWithChildren,
  GeneratorRoute: GeneratorRoute,
  GridRoute: GridRoute,
  IngestRoute: IngestRoute,
  LoginRoute: LoginRoute,
  ReportsRoute: ReportsRoute,
  TradesRoute: TradesRoute,
  EexDeliveryRoute: EexDeliveryRoute,
  EexFxRoute: EexFxRoute,
  EexMarginRoute: EexMarginRoute,
  EexMarginLabRoute: EexMarginLabRoute,
  EexMarketDataRoute: EexMarketDataRoute,
  EexMatchingRoute: EexMatchingRoute,
  EexPnlRoute: EexPnlRoute,
  EexPositionsRoute: EexPositionsRoute,
  EexPositionsTreeRoute: EexPositionsTreeRoute,
  EexQuotesRoute: EexQuotesRoute,
  EexRecognitionSchedulesRoute: EexRecognitionSchedulesRoute,
  EexResearchRoute: EexResearchRoute,
  EexSettingsRoute: EexSettingsRoute,
  EexStatementsRoute: EexStatementsRoute,
  EexStatsRoute: EexStatsRoute,
  EexTradesRoute: EexTradesRoute,
  SettingsBrmRoute: SettingsBrmRoute,
  EexIndexRoute: EexIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
